<template>
  <div class="select-suggestion">
    <slot name="label">
      <div
        v-if="label || $t(`suggestable_models.${this.model}`)"
        :class="`label-div text-sm ${focused ? 'text-primary' : ''}`"
      >
        <label>{{ label || $t(`suggestable_models.${this.model}`) }}</label>
      </div>
    </slot>
    <div class="flex flex-row gap-1 w-full">
      <div class="min-h-full w-full relative">
        <vs-select
          ref="select"
          class="w-full"
          autocomplete
          v-model="selectedModelId"
          @input-change="searchSuggestions"
          :placeholder="translatedPlaceholderText"
          :danger="selectedModel === undefined"
          danger-text="Seleção inválida"
          @input="selectModel"
          :noData="noData"
          @focus="onFocus"
          @blur="focused = false"
          :disabled="disabled"
        >
          <vs-select-item
            :key="model.id"
            :value="model.id"
            :text="itemTextFormat(model)"
            v-for="(model) in suggestedModels"
          />
        </vs-select>

        <div class="loadingContainer absolute inset-0 pointer-events-none p-3 pr-6 flex items-center justify-end">
          <!-- <feather-icon icon="RotateCwIcon" class="animate-spin text-primary"/>
          <label class="text-primary">buscando</label> -->
        </div>
      </div>

      <!-- Botão de limpar ao lado -->
      <div
        v-if="selectedModelId && appendClearOption"
        class="flex-shrink-0 flex items-center"
      >
        <button
          type="button"
          @click.stop.prevent="clearSelection($event)"
          class="clear-button-side p-2 rounded border border-gray-300 hover:border-red-400 hover:bg-red-50 transition-all"
          v-tooltip.top="{content: 'Limpar seleção',delay: { show: 100, hide: 100 }}"
        >
          <b-icon-x class="text-gray-500 hover:text-red-500" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SuggestionService from '@/services/api/SuggestionService'
import VxInputGroup from './vx-input-group/VxInputGroup.vue'
import {
  BButton,
  BIconX,
  VBTooltip,
} from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    onlySuggestion: {
      type: Boolean,
      default: true
    },
    placeholderText: {
      type: String,
      default: ''
    },
    model: {
      type: String,
      default: null
    },
    column: {
      type: String,
      default: null
    },
    max: {
      type: Number,
      default: 5
    },
    orderBy:{
      type: String,
      default: 'id'
    },
    itemTextFormat: {
      type: Function,
      default: (model) => {
        return model.name || model.title || model.description || model.id
      }
    },
    selectedModel: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    noDataText: {
      type: String,
      default: 'Nenhum valor encontrado, informe outro valor para pesquisar.'
    },
    appendClearOption: {
      type: Boolean,
      default: true
    },
    clearAfterSelection: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    promptText: {
      type: String,
      default: 'Informe um valor para pesquisar.'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    extraParamsFilters: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    VxInputGroup,
    BButton,
    BIconX,
  },

  data: () => ({
    selectedModelId: null,
    suggestionService: null,
    suggestedModels: [],
    timeout: null,
    focused: false,
    searchInputValue: '',
    lastSuggestionCount: null
  }),

  model: {
    prop: 'selectedModel',
    event: 'selected-model'
  },

  watch: {
    max(v) {
      this.changeServiceParam('max', v)
    },
    model(v) {
      this.changeServiceParam('model', v)
    },
    column(v) {
      this.changeServiceParam('property', v)
    }
  },

  mounted() {
    this.suggestionService = SuggestionService.buildOnModel(
      this.model,
      this.column,
      this.max,
      [],
      this.$vs
    )
    this.guaranteeModelDisplay()

    // Interceptar cliques em botões internos do vs-select para prevenir submit
    this.$nextTick(() => {
      const selectElement = this.$refs.select?.$el
      if (selectElement) {
        selectElement.addEventListener('click', (event) => {
          // Verificar se o clique foi em um botão interno
          const target = event.target
          if (target.tagName === 'BUTTON' || target.closest('button')) {
            event.preventDefault()
            event.stopPropagation()
          }
        }, true) // usar capture para interceptar antes
      }
    })
  },

  beforeUpdate() {
    this.guaranteeModelDisplay()
  },

  computed: {
    showAppendButtons() {
      return (this.selectedModelId && this.appendClearOption)
    },
    select() {
      return this.$refs['select']
    },
    searchinput() {
      return this.$refs['select'].$refs['inputselect']
    },
    noData() {

      if (!this.isEmpty(this.searchInputValue) && this.lastSuggestionCount === 0) {
        return this.noDataText
      }

      return this.promptText
    },
    translatedPlaceholderText() {
      const model = `${this.model.toString().toLowerCase()}`
      return this.placeholderText || this.$t(`placeholders.select_suggestion.${model}`)
    }
  },

  methods: {
    changeServiceParam(param, v) {
      if (this.suggestionService) this.suggestionService[param] = v
    },
    selectModel(id) {
      const selectedModel = this.suggestedModels.find(model => model.id === id)
      this.selectedModel = selectedModel
      this.suggestedModels = [this.selectedModel]
      this.selectedModelId = selectedModel.id
      this.emitSelection()

      if (this.clearAfterSelection) {
        setTimeout(() => {
          this.reset()
        }, 100)
      }
    },
    fill(model) {
      this.selectedModel = model
      this.suggestedModels = [model]
      this.selectedModelId = model.id
      this.emitSelection()
    },
    clearSelection(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }

      // Limpeza controlada sem manipular o DOM diretamente
      this.suggestedModels = []
      this.selectedModel = null
      this.selectedModelId = null
      this.lastSuggestionCount = null

      // Usar o método do vs-select para limpar
      if (this.select && this.select.clear) {
        this.select.clear = true
      }

      this.emitSelection()
      this.$emit('clearSelection')
    },
    guaranteeModelDisplay() {
      if (!this.isEmpty(this.selectedModel) && this.isEmpty(this.selectedModelId)) {
        this.selectedModelId = this.selectedModel.id
        this.suggestedModels = [this.selectedModel]
      }
    },
    fetchSuggestion(search) {
      if (search && search.length) {
        this.showLoading()
        this.suggestionService.fetchSuggestion(search, null, null, this.extraParamsFilters).then(response => {
          this.lastSuggestionCount = response.length
          if (response.length > 0) {
            this.select.clear = false
          } else {
            this.select.clear = true
          }
          this.closeLoading()
          this.suggestedModels = response
          clearTimeout(this.timeout)
          this.timeout = null
        }, error => {
          this.closeLoading()
        })
      }
    },
    searchSuggestions() {
      if (this.timeout) clearTimeout(this.timeout)

      this.searchInputValue = this.searchinput.value

      const search = this.searchinput.value
      if (!this.isEmpty(search)) {
        this.timeout = setTimeout(() => {
          this.fetchSuggestion(search)
        }, 500)
      } else {
        this.select.clear = false
        this.reset()
      }
    },
    emitSelection() {
      this.$emit('selected-model', this.selectedModel)
    },
    reset() {
      this.suggestedModels = []
      this.selectedModel = null
      this.selectedModelId = null
      this.searchinput.value = ''
      this.lastSuggestionCount = null
      this.emitSelection()
    },
    onFocus(event) {
      this.searchInputValue = this.searchinput.value
      this.focused = true
      this.fetchSuggestion('')
    },
    showLoading() {
      const inputSelect = document.querySelector('.loadingContainer')
      if (inputSelect) {
        this.$vs.loading({
          container: inputSelect,
          scale: 0.6
        })
      }
    },
    closeLoading() {
      const inputSelect = document.querySelector('.loadingContainer')
      if (inputSelect) {
        this.$vs.loading.close(inputSelect)
      }
    }
  },


}
</script>

<style lang="scss">
  .select-suggestion {
    height: min-content;
  }

  .select-suggestion .btn-outline-danger:hover {
    background-color: #dc3545;
    border-color: #dc3545;
    color: white;
  }

  .select-suggestion .btn-outline-danger:hover svg {
    color: white;
  }

  .clear-button-side {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    height: 38px;
    border: 1px solid #d1d5db;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: #ef4444;
      background-color: #fef2f2;
    }

    svg {
      width: 16px;
      height: 16px;
      transition: color 0.2s ease;
    }

    &:hover svg {
      color: #ef4444 !important;
    }
  }

  // Esconder o botão de limpar interno do vs-select para evitar submit indesejado
  .select-suggestion .vs-select {
    .vs-select__clear {
      display: none !important;
    }

    .vs__clear {
      display: none !important;
    }
  }
</style>
